<template>
  <div class="feefo-badge">
    <a
      href="https://ww2.feefo.com/reviews/pitchup-com"
      target="_blank"
      rel="external nofollow noopener"
    >
      <img
        v-if="showServiceRating"
        loading="lazy"
        :src="badgeLink"
        width="270"
        height="68"
        class="feefo-service-rating"
        :alt="$t('Feefo service rating')"
        :title="$t('Visit Feefo - and see what our customers say about us')"
      />
      <img
        src="@/assets/images/feefo_platinum_service_2025.png"
        width="270"
        height="85"
        class="feefo-platinum-badge"
        :alt="altTagText"
      />
    </a>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class FeefoBadge extends Vue {
  @Prop({ default: true })
  showServiceRating: boolean

  get badgeLink() {
    return this.$i18n.localeInfo.feefoBadge
  }

  get altTagText() {
    return this.$t('Feefo platinum service award {currentYear}', {
      currentYear: new Date().getFullYear(),
    })
  }
}

export default toNative(FeefoBadge)
</script>

<style scoped>
div {
  text-align: center;
  margin: 2em 1.4em;
}

a {
  display: flex;
  text-decoration: none;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  gap: 1.5em;
}

img {
  max-width: 100%;
  width: 270px;
  height: auto;
}
</style>
